import { Component, OnInit, ViewChild } from '@angular/core';
import {
  DVFormGroup,
  DVFormControl
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { ActivatedRoute, Router } from '@angular/router';
import { AboutsService } from '../abouts.service';
import { QuillEditorComponent } from 'ngx-quill';
import { FileHolder } from 'angular2-image-upload';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  aboutForm: DVFormGroup;
  isAddState = true;
  groups : [];
  @ViewChild('editor', {
    static: true
  })
  editor: QuillEditorComponent;
  constructor(
    private aboutApi: AboutsService,
    private notifier: SnotifyService,
    private route: ActivatedRoute,
    private router: Router
  ) {
      
      this.aboutApi.getAboutById(1).subscribe((Response)=>{
        console.log(Response.data.about, ' lllllll');
        if (Response.data.about.length === 0) {
          this.isAddState = true;
        } else {
          this.isAddState = false;
          this.aboutForm.patchValue(Response.data.about);

        }
      });
    this.aboutForm = new DVFormGroup({
      content: new DVFormControl(),
      image: new DVFormControl(),
      imageAlt: new DVFormControl(),
      imageTitle: new DVFormControl(),
      metaTitle: new DVFormControl(),
      metaDescription: new DVFormControl(),
      metaKeywords: new DVFormControl(),
    });
  }

  ngOnInit() {}
  SubmitForm() {
    if (this.aboutForm.valid) {
      console.log('Content', this.aboutForm.value);
      if (this.isAddState == true) {
        this.aboutApi.addAbout(this.aboutForm.value).subscribe(Response => {
          console.log(Response + 'ssssssssssssssssssssss');
          this.notifier.success('About Has Added Successfully');
        });
      } else {
        this.aboutForm.value.id = 1;
        this.aboutApi.editAbout(this.aboutForm.value, 1).subscribe((Response) => {
          console.log(Response);
          this.notifier.success('About Edited Successfully');
        }, err => {
          this.notifier.error(err.error.userMessage);
        });
      }
    } else {
      this.aboutForm.forceShowErrors();
    }
  }
  imageUploaded(holder: FileHolder) {
    if (holder.serverResponse.status === 200) {
      const imageBody = holder.serverResponse.response.body;
      delete imageBody.message;
      this.addImage(imageBody);
    }
  }
  private addImage(src) {
    const control = <DVFormControl> this.aboutForm.controls[`image`];
    const value: string = control.value || '';
    control.setValue(src.data.filePath);
  }

  imageRemoved(holder: FileHolder) {
  }
  // EditForm() {
  //   if (this.aboutForm.valid) {
  //   this.aboutForm.value.id = this.route.snapshot.params.id;
  //   this.aboutApi.editAbout(this.aboutForm.value, this.route.snapshot.params.id).subscribe((Response) => {
  //     console.log(Response);
  //     this.notifier.success('About Edited Successfully');
  //   }, err => {
  //     this.notifier.error(err.error.userMessage);
  //   });
  //  } else {
  //   this.aboutForm.forceShowErrors();
  // }
  // }
}
